module.exports = function _of(x) { return [x]; };



//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_of.js
// module id = 1396
// module chunks = 1